import { useEffect, useState } from 'react'
import API from '../../../services/API'

// 'Vehicle' lists fit vehicles; every other type is an asset (bag, device)
// list. Shared so the board, asset drawer and asset page filter identically.
export const loadListsForKind = (loadLists, kind) =>
  (loadLists || []).filter((list) =>
    kind === 'vehicle' ? list.type === 'Vehicle' : list.type !== 'Vehicle',
  )

const useLoadLists = ({ enabled = true } = {}) => {
  const [loadLists, setLoadLists] = useState([])
  const [loading, setLoading] = useState(enabled)
  const [fetchError, setFetchError] = useState(false)

  useEffect(() => {
    if (!enabled) return undefined
    let active = true
    setLoading(true)
    setFetchError(false)
    API.get('/settings/makereadyloadlists', { params: { types: 'all' } })
      .then((res) => {
        if (!active) return
        if (res.status === 200 && Array.isArray(res.data)) {
          setLoadLists(res.data)
        } else {
          setFetchError(true)
        }
      })
      .catch(() => {
        if (active) setFetchError(true)
      })
      .finally(() => {
        if (active) setLoading(false)
      })
    return () => {
      active = false
    }
  }, [enabled])

  return { loadLists, loading, fetchError }
}

export default useLoadLists
